import { motion } from "framer-motion";
import { IMAGES, MANIFESTO } from "@/lib/data";

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-24 sm:py-32 border-b border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="font-mono-tech text-[11px] tracking-[0.25em] text-[#FF5E1E] mb-4">[ SEC—MANIFESTO — WHY REENTRY STAFFING ]</div>
            <h2 className="font-display font-black uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]">
              We don't just find people jobs.<br /><span className="text-[#FF5E1E]">We build skilled workers.</span>
            </h2>
            <div className="mt-8 relative">
              <img src={IMAGES.sparks} alt="Welding sparks" className="w-full h-64 object-cover grayscale contrast-125" />
              <div className="absolute inset-0 border border-[#FF5E1E]/40 translate-x-2 translate-y-2 -z-10" />
              <div className="absolute bottom-3 left-3 font-mono-tech text-[10px] tracking-[0.2em] text-white bg-[#0B0F14]/80 px-2 py-1">FIREWATCH → TRADE → CAREER</div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-0">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5 }}
                className="grid grid-cols-[auto_1fr] gap-6 py-8 border-b border-white/10 first:pt-0"
              >
                <div className="font-display font-black text-5xl sm:text-6xl text-[#182230] leading-none select-none">{m.n}</div>
                <div>
                  <h3 className="font-display font-bold uppercase text-xl sm:text-2xl">{m.title}</h3>
                  <p className="mt-2 text-[#8FA3B8] leading-relaxed">{m.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
